import { List } from '../objects/list';
import { Code } from '../objects/code';
import { Error } from '../objects/error';
import { Contact } from '../objects/contact';
import { Contract } from '../objects/contract';
import { PaymentDelay } from '../objects/paymentDelay';
import { Picture } from '../../picture/objects/picture';
import { Currency } from '../../currency/objects/currency';
import { CustomProvider } from '../objects/customProvider';
import { Preferences } from '../../profile/objects/preferences';
import { BankingInformation } from '../objects/bankingInformation';
import { Errors as PictureErrors } from '../../picture/objects/errors';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Settlement } from '../objects/settlement';
import { Column } from '../objects/column';
import { EventSiteDate } from '../objects/eventSiteDate';

export const ADD_BANKING_INFORMATION = 'CUSTOM_PROVIDER_ADD_BANKING_INFORMATION';
export const ADD_CODE = 'CUSTOM_PROVIDER_ADD_CODE';
export const ADD_CONTACT = 'CUSTOM_PROVIDER_ADD_CONTACT';
export const ADD_CONTRACT = 'CUSTOM_PROVIDER_ADD_CONTRACT';
export const ADD_PAYMENT_DELAY = 'CUSTOM_PROVIDER_ADD_PAYMENT_DELAY';
export const ADD_PREFERENCES = 'CUSTOM_PROVIDER_ADD_PREFERENCES';
export const DELETE_BANKING_INFORMATION = 'CUSTOM_PROVIDER_DELETE_BANKING_INFORMATION';
export const DELETE_CODE = 'CUSTOM_PROVIDER_DELETE_CODE';
export const DELETE_CONTACT = 'CUSTOM_PROVIDER_DELETE_CONTACT';
export const DELETE_CONTRACT = 'CUSTOM_PROVIDER_DELETE_CONTRACT';
export const DELETE_PAYMENT_DELAY = 'CUSTOM_PROVIDER_DELETE_PAYMENT_DELAY';
export const MOVE_DOWN_COLUMN = 'CUSTOM_PROVIDER_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'CUSTOM_PROVIDER_MOVE_UP_COLUMN';
export const RESET_CUSTOM_PROVIDER = 'CUSTOM_PROVIDER_RESET_CUSTOM_PROVIDER';
export const RESET_FILTERS = 'CUSTOM_PROVIDER_RESET_FILTERS';
export const SET_BANKING_INFORMATION_DELETE = 'CUSTOM_PROVIDER_SET_BANKING_INFORMATION_DELETE';
export const SET_BANKING_INFORMATION_LIST = 'CUSTOM_PROVIDER_SET_BANKING_INFORMATION_LIST';
export const SET_CODE_DELETE = 'CUSTOM_PROVIDER_SET_CODE_DELETE';
export const SET_CODE_LIST = 'CUSTOM_PROVIDER_SET_CODE_LIST';
export const SET_CONTACT_DELETE = 'CUSTOM_PROVIDER_SET_CONTACT_DELETE';
export const SET_CONTACT_LIST = 'CUSTOM_PROVIDER_SET_CONTACT_LIST';
export const SET_CONTRACT_ACTIVATE = 'CUSTOM_PROVIDER_SET_CONTRACT_ACTIVATE';
export const SET_CONTRACT_LIST = 'CUSTOM_PROVIDER_SET_CONTRACT_LIST';
export const SET_CONTRACT_LOCK = 'CUSTOM_PROVIDER_SET_CONTRACT_LOCK';
export const SET_CONTRACT_IS_DEACTIVATED = 'CUSTOM_PROVIDER_SET_CONTRACT_IS_DEACTIVATED';
export const SET_CUSTOM_PROVIDER = 'CUSTOM_PROVIDER_SET_CUSTOM_PROVIDER';
export const SET_CUSTOM_PROVIDER_ACTIVATE = 'CUSTOM_PROVIDER_SET_CUSTOM_PROVIDER_ACTIVATE';
export const SET_CUSTOM_PROVIDER_BANKING_INFORMATIONS = 'CUSTOM_PROVIDER_SET_CUSTOM_PROVIDER_BANKING_INFORMATIONS';
export const SET_CUSTOM_PROVIDER_CODES = 'CUSTOM_PROVIDER_SET_CUSTOM_PROVIDER_CODES';
export const SET_CUSTOM_PROVIDER_CONTRACTS = 'CUSTOM_PROVIDER_SET_CUSTOM_PROVIDER_CONTRACTS';
export const SET_CUSTOM_PROVIDER_CONTACTS = 'CUSTOM_PROVIDER_SET_CUSTOM_PROVIDER_CONTACTS';
export const SET_CUSTOM_PROVIDER_PAYMENT_DELAYS = 'CUSTOM_PROVIDER_SET_CUSTOM_PROVIDER_PAYMENT_DELAYS';
export const SET_CUSTOM_PROVIDER_PAYMENT_DELAY_EDIT = 'CUSTOM_PROVIDER_SET_CUSTOM_PROVIDER_PAYMENT_DELAY_EDIT';
export const SET_EDIT_STEP = 'CUSTOM_PROVIDER_SET_EDIT_STEP';
export const SET_ERRORS = 'CUSTOM_PROVIDER_SET_ERRORS';
export const SET_EXPORT_TYPE = 'CUSTOM_PROVIDER_SET_EXPORT_TYPE';
export const SET_LIMIT = 'CUSTOM_PROVIDER_SET_LIMIT';
export const SET_LIST = 'CUSTOM_PROVIDER_SET_LIST';
export const SET_LIST_CONTRACT_RELOAD = 'CUSTOM_PROVIDER_SET_LIST_CONTRACT_RELOAD';
export const SET_ORDER_BY = 'CUSTOM_PROVIDER_SET_ORDER_BY';
export const SET_PAGE = 'CUSTOM_PROVIDER_SET_PAGE';
export const SET_PAYMENT_DELAYS_DELETE = 'CUSTOM_PROVIDER_SET_PAYMENT_DELAYS_DELETE';
export const SET_PAYMENT_DELAYS_LIST = 'CUSTOM_PROVIDER_SET_PAYMENT_DELAYS_LIST';
export const SET_PICTURE_ERRORS = 'CUSTOM_PROVIDER_SET_PICTURE_ERRORS';
export const SET_POST_FINISHED = 'CUSTOM_PROVIDER_SET_POST_FINISHED';
export const SET_PREFERENCES = 'CUSTOM_PROVIDER_SET_PREFERENCES';
export const SET_RUNNING = 'CUSTOM_PROVIDER_SET_RUNNING';
export const SET_SEARCH = 'CUSTOM_PROVIDER_SET_SEARCH';
export const TOGGLE_AUTO_BOOKING = 'CUSTOM_PROVIDER_TOGGLE_AUTO_BOOKING';
export const TOGGLE_COLUMN = 'CUSTOM_PROVIDER_TOGGLE_COLUMN';
export const TOGGLE_CONTRACT_ACTIVATED = 'CUSTOM_PROVIDER_TOGGLE_CONTRACT_ACTIVATED';
export const TOGGLE_CREATE = 'CUSTOM_PROVIDER_TOGGLE_CREATE';
export const TOGGLE_EDIT = 'CUSTOM_PROVIDER_TOGGLE_EDIT';
export const TOGGLE_EXPORT = 'CUSTOM_PROVIDER_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'CUSTOM_PROVIDER_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'CUSTOM_PROVIDER_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'CUSTOM_PROVIDER_TOGGLE_REFRESH';
export const UPDATE_ACTIVATION_COUNTRIES = 'CUSTOM_PROVIDER_UPDATE_ACTIVATION_COUNTRIES';
export const UPDATE_ADDRESS = 'CUSTOM_PROVIDER_UPDATE_ADDRESS';
export const UPDATE_ASSISTANCE_EMAIL = 'CUSTOM_PROVIDER_UPDATE_ASSISTANCE_EMAIL';
export const UPDATE_ASSISTANCE_PHONE_NUMBER = 'CUSTOM_PROVIDER_UPDATE_ASSISTANCE_PHONE_NUMBER';
export const UPDATE_BANKING_ACCOUNT_HOLDER = 'CUSTOM_PROVIDER_UPDATE_BANKING_ACCOUNT_HOLDER';
export const UPDATE_BANKING_ADDRESS = 'CUSTOM_PROVIDER_UPDATE_BANKING_ADDRESS';
export const UPDATE_BANKING_BIC = 'CUSTOM_PROVIDER_UPDATE_BANKING_BIC';
export const UPDATE_BANKING_CITY = 'CUSTOM_PROVIDER_UPDATE_BANKING_CITY';
export const UPDATE_BANKING_COUNTRY = 'CUSTOM_PROVIDER_UPDATE_BANKING_COUNTRY';
export const UPDATE_BANKING_CURRENCY = 'CUSTOM_PROVIDER_UPDATE_BANKING_CURRENCY';
export const UPDATE_BANKING_IBAN = 'CUSTOM_PROVIDER_UPDATE_BANKING_IBAN';
export const UPDATE_BANKING_NAME = 'CUSTOM_PROVIDER_UPDATE_BANKING_NAME';
export const UPDATE_BANKING_ZIP_CODE = 'CUSTOM_PROVIDER_UPDATE_BANKING_ZIP_CODE';
export const UPDATE_BOOKING_EMAIL = 'CUSTOM_PROVIDER_UPDATE_BOOKING_EMAIL';
export const UPDATE_CITY = 'CUSTOM_PROVIDER_UPDATE_CITY';
export const UPDATE_CODE = 'CUSTOM_PROVIDER_UPDATE_CODE';
export const UPDATE_PROVIDER_CODE = 'CUSTOM_PROVIDER_UPDATE_PROVIDER_CODE';
export const UPDATE_CODE_CODE = 'CUSTOM_PROVIDER_UPDATE_CODE_CODE';
export const UPDATE_CODE_CURRENCY = 'CUSTOM_PROVIDER_UPDATE_CODE_CURRENCY';
export const UPDATE_COMPLEMENTARY_ADDRESS = 'CUSTOM_PROVIDER_UPDATE_COMPLEMENTARY_ADDRESS';
export const UPDATE_CONTACT_CONTACT_EMAIL = 'CUSTOM_PROVIDER_UPDATE_CONTACT_CONTACT_EMAIL';
export const UPDATE_CONTACT_DETAILS_LOCALE = 'CUSTOM_PROVIDER_UPDATE_CONTACT_DETAILS_LOCALE';
export const UPDATE_CONTACT_DETAILS = 'CUSTOM_PROVIDER_UPDATE_CONTACT_DETAILS';
export const UPDATE_CONTACT_EMAIL = 'CUSTOM_PROVIDER_UPDATE_CONTACT_EMAIL';
export const UPDATE_CONTACT_FIRST_NAME = 'CUSTOM_PROVIDER_UPDATE_CONTACT_FIRST_NAME';
export const UPDATE_CONTACT_FUNCTION = 'CUSTOM_PROVIDER_UPDATE_CONTACT_FUNCTION';
export const UPDATE_CONTACT_LAST_NAME = 'CUSTOM_PROVIDER_UPDATE_CONTACT_LAST_NAME';
export const UPDATE_CONTACT_PHONE_NUMBER = 'CUSTOM_PROVIDER_UPDATE_CONTACT_PHONE_NUMBER';
export const UPDATE_CONTENT_TYPE = 'CUSTOM_PROVIDER_UPDATE_CONTENT_TYPE';
export const UPDATE_CONTRACT_CURRENCY = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_CURRENCY';
export const UPDATE_CONTRACT_EVENT_SITE_DATE = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_EVENT_SITE_DATE';
export const UPDATE_CONTRACT_END_DATE = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_END_DATE';
export const UPDATE_CONTRACT_NAME = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_NAME';
export const UPDATE_CONTRACT_NAME_LOCALE = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_NAME_LOCALE';
export const UPDATE_CONTRACT_SECOND_STOCK_TYPE = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_SECOND_STOCK_TYPE';
export const UPDATE_CONTRACT_START_DATE = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_START_DATE';
export const UPDATE_CONTRACT_STOCK_TYPE = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_STOCK_TYPE';
export const UPDATE_CONTRACT_TYPE = 'CUSTOM_PROVIDER_UPDATE_CONTRACT_TYPE';
export const UPDATE_VA_CONTENT_TYPE = 'CUSTOM_PROVIDER_UPDATE_VA_CONTENT_TYPE';
export const UPDATE_COUNTRY = 'CUSTOM_PROVIDER_UPDATE_COUNTRY';
export const UPDATE_COUNTY_CODE = 'CUSTOM_PROVIDER_UPDATE_COUNTY_CODE';
export const UPDATE_FILTER_ACTIVATED = 'CUSTOM_PROVIDER_UPDATE_FILTER_ACTIVATED';
export const UPDATE_FILTER_COUNTRY = 'CUSTOM_PROVIDER_UPDATE_FILTER_COUNTRY';
export const UPDATE_FILTER_CONTENT_TYPE = 'CUSTOM_PROVIDER_UPDATE_FILTER_CONTENT_TYPE';
export const UPDATE_FILTER_VA_CONTENT_TYPE = 'CUSTOM_PROVIDER_UPDATE_FILTER_VA_CONTENT_TYPE';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'CUSTOM_PROVIDER_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'CUSTOM_PROVIDER_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'CUSTOM_PROVIDER_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_LAST_AUTHOR = 'CUSTOM_PROVIDER_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'CUSTOM_PROVIDER_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'CUSTOM_PROVIDER_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_NAME = 'CUSTOM_PROVIDER_UPDATE_FILTER_NAME';
export const UPDATE_FILTER_PERIOD = 'CUSTOM_PROVIDER_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'CUSTOM_PROVIDER_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_LANGUAGE = 'CUSTOM_PROVIDER_UPDATE_LANGUAGE';
export const UPDATE_NAME = 'CUSTOM_PROVIDER_UPDATE_NAME';
export const UPDATE_PAYMENT_DELAY = 'CUSTOM_PROVIDER_UPDATE_PAYMENT_DELAY';
export const UPDATE_PAYMENT_DELAY_CURRENCY = 'CUSTOM_PROVIDER_UPDATE_PAYMENT_DELAY_CURRENCY';
export const UPDATE_PAYMENT_DELAY_NEGATIVE = 'CUSTOM_PROVIDER_UPDATE_PAYMENT_DELAY_NEGATIVE';
export const UPDATE_PAYMENT_DELAY_TYPE = 'CUSTOM_PROVIDER_UPDATE_PAYMENT_DELAY_TYPE';
export const UPDATE_PAYMENT_TYPE = 'CUSTOM_PROVIDER_UPDATE_PAYMENT_TYPE';
export const UPDATE_PHONE_NUMBER = 'CUSTOM_PROVIDER_UPDATE_PHONE_NUMBER';
export const UPDATE_VAT_NUMBER = 'CUSTOM_PROVIDER_UPDATE_VAT_NUMBER';
export const UPDATE_FISCAL_CODE = 'CUSTOM_PROVIDER_UPDATE_FISCAL_CODE';
export const UPDATE_MASTER_CODE = 'CUSTOM_PROVIDER_UPDATE_MASTER_CODE';
export const UPDATE_COUNTER_CODE = 'CUSTOM_PROVIDER_UPDATE_COUNTER_CODE';
export const UPDATE_PICTURE = 'CUSTOM_PROVIDER_UPDATE_PICTURE';
export const UPDATE_PICTURE_PROGRESS = 'CUSTOM_PROVIDER_UPDATE_PICTURE_PROGRESS';
export const UPDATE_SECONDARY_PHONE_NUMBER = 'CUSTOM_PROVIDER_UPDATE_SECONDARY_PHONE_NUMBER';
export const UPDATE_MOBILE_PHONE_NUMBER = 'CUSTOM_PROVIDER_UPDATE_MOBILE_PHONE_NUMBER';
export const UPDATE_ZIP_CODE = 'CUSTOM_PROVIDER_UPDATE_ZIP_CODE';
export const UPDATE_WEBSITE = 'CUSTOM_PROVIDER_UPDATE_WEBSITE';
export const SET_PAYMENT_DELAY_CREATE = 'CUSTOM_PROVIDER_SET_PAYMENT_DELAY_CREATE';
export const SET_COLUMNS = 'CUSTOM_PROVIDER_SET_COLUMNS';
export const RESIZE_COLUMN = 'CUSTOM_PROVIDER_RESIZE_COLUMN';

interface ResizeColumnAction {
    type: typeof RESIZE_COLUMN,
    payload: { field_name: string; width: number }
}

interface SetPaymentDelayCreate {
    type: typeof SET_PAYMENT_DELAY_CREATE,
    payload: boolean
}
interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}
interface AddBankingInformationAction {
    type: typeof ADD_BANKING_INFORMATION
}

interface AddCodeAction {
    type: typeof ADD_CODE
}

interface AddContactAction {
    type: typeof ADD_CONTACT
}

interface AddContractAction {
    type: typeof ADD_CONTRACT
}

interface AddPaymentDelayAction {
    type: typeof ADD_PAYMENT_DELAY
}

interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface DeleteBankingInformationAction {
    type: typeof DELETE_BANKING_INFORMATION,
    payload: number
}

interface DeleteCodeAction {
    type: typeof DELETE_CODE,
    payload: number
}

interface DeleteContactAction {
    type: typeof DELETE_CONTACT,
    payload: number
}

interface DeleteContractAction {
    type: typeof DELETE_CONTRACT,
    payload: number
}

interface DeletePaymentDelayAction {
    type: typeof DELETE_PAYMENT_DELAY,
    payload: number
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetCustomProviderAction {
    type: typeof RESET_CUSTOM_PROVIDER
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetCustomProviderActivateAction {
    type: typeof SET_CUSTOM_PROVIDER_ACTIVATE,
    payload: null | CustomProvider | false
}

interface SetBankingInformationDeleteAction {
    type: typeof SET_BANKING_INFORMATION_DELETE,
    payload: null | BankingInformation | false
}

interface SetBankingInformationListAction {
    type: typeof SET_BANKING_INFORMATION_LIST,
    payload: BankingInformation[]
}

interface SetCodeDeleteAction {
    type: typeof SET_CODE_DELETE,
    payload: null | Code | false
}

interface SetCodeListAction {
    type: typeof SET_CODE_LIST,
    payload: Code[]
}

interface SetContactDeleteAction {
    type: typeof SET_CONTACT_DELETE,
    payload: null | Contact | false
}

interface SetContactListAction {
    type: typeof SET_CONTACT_LIST,
    payload: Contact[]
}

interface SetContractActivateAction {
    type: typeof SET_CONTRACT_ACTIVATE,
    payload: null | Contract | false
}

interface SetContractListAction {
    type: typeof SET_CONTRACT_LIST,
    payload: Contract[]
}

interface SetContractLockAction {
    type: typeof SET_CONTRACT_LOCK,
    payload: null | Contract | false
}
interface SetContractIsDeactivatedAction {
    type: typeof SET_CONTRACT_IS_DEACTIVATED,
    payload: null | Contract | false
}
interface SetCustomProviderAction {
    type: typeof SET_CUSTOM_PROVIDER,
    payload: CustomProvider
}

interface SetCustomProviderBankingInformationsAction {
    type: typeof SET_CUSTOM_PROVIDER_BANKING_INFORMATIONS,
    payload: boolean | null | BankingInformation
}

interface SetCustomProviderCodesAction {
    type: typeof SET_CUSTOM_PROVIDER_CODES,
    payload: boolean | null | Code
}

interface SetCustomProviderContractsAction {
    type: typeof SET_CUSTOM_PROVIDER_CONTRACTS,
    payload: boolean | null | Contract
}

interface SetCustomProviderContactsAction {
    type: typeof SET_CUSTOM_PROVIDER_CONTACTS,
    payload: boolean | null | Contact
}

interface SetCustomProviderPaymentDelaysAction {
    type: typeof SET_CUSTOM_PROVIDER_PAYMENT_DELAYS,
    payload: Settlement[]
}
interface SetCustomProviderPaymentDelayEditAction {
    type: typeof SET_CUSTOM_PROVIDER_PAYMENT_DELAY_EDIT,
    payload: Settlement | null
}

interface SetEditStepAction {
    type: typeof SET_EDIT_STEP,
    payload: 'INFO' | 'CONTACT' | 'CONTRACT' | 'CODE' | 'BANKING_INFORMATION' | 'PAYMENT_DELAY' | 'ACCOUNTING'
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Error[]
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetListContractReloadAction {
    type: typeof SET_LIST_CONTRACT_RELOAD,
    payload: null | number
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPaymentDelaysDeleteAction {
    type: typeof SET_PAYMENT_DELAYS_DELETE,
    payload: null | Settlement
}

interface SetPaymentDelaysListAction {
    type: typeof SET_PAYMENT_DELAYS_LIST,
    payload: PaymentDelay[]
}

interface SetPictureErrorsAction {
    type: typeof SET_PICTURE_ERRORS,
    payload: PictureErrors | null
}

interface SetPostFinishedAction {
    type: typeof SET_POST_FINISHED
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleAutoBookingAction {
    type: typeof TOGGLE_AUTO_BOOKING
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleContractActivatedAction {
    type: typeof TOGGLE_CONTRACT_ACTIVATED,
    payload: number
}

interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleEditAction {
    type: typeof TOGGLE_EDIT
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateActivationCountriesAction {
    type: typeof UPDATE_ACTIVATION_COUNTRIES,
    payload: IataCountry[]
}

interface UpdateAddressAction {
    type: typeof UPDATE_ADDRESS,
    payload: string
}

interface UpdateAssistanceEmailAction {
    type: typeof UPDATE_ASSISTANCE_EMAIL,
    payload: string
}

interface UpdateAssistancePhoneNumberAction {
    type: typeof UPDATE_ASSISTANCE_PHONE_NUMBER,
    payload: string
}

interface UpdateBankingAccountHolderAction {
    type: typeof UPDATE_BANKING_ACCOUNT_HOLDER,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateBankingAddressAction {
    type: typeof UPDATE_BANKING_ADDRESS,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateBankingBicAction {
    type: typeof UPDATE_BANKING_BIC,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateBankingCityAction {
    type: typeof UPDATE_BANKING_CITY,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateBankingCountryAction {
    type: typeof UPDATE_BANKING_COUNTRY,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateBankingCurrencyAction {
    type: typeof UPDATE_BANKING_CURRENCY,
    payload: {
        value: null | Currency,
        index: number
    }
}

interface UpdateBankingIbanAction {
    type: typeof UPDATE_BANKING_IBAN,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateBankingNameAction {
    type: typeof UPDATE_BANKING_NAME,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateBankingZipCodeAction {
    type: typeof UPDATE_BANKING_ZIP_CODE,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateBookingEmailAction {
    type: typeof UPDATE_BOOKING_EMAIL,
    payload: string
}

interface UpdateCityAction {
    type: typeof UPDATE_CITY,
    payload: string
}

interface UpdateCodeAction {
    type: typeof UPDATE_CODE,
    payload: string
}
interface UpdateProviderCodeAction {
    type: typeof UPDATE_PROVIDER_CODE,
    payload: string
}

interface UpdateCodeCodeAction {
    type: typeof UPDATE_CODE_CODE,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateCodeCurrencyAction {
    type: typeof UPDATE_CODE_CURRENCY,
    payload: {
        value: null | Currency,
        index: number
    }
}

interface UpdateComplementaryAddressAction {
    type: typeof UPDATE_COMPLEMENTARY_ADDRESS,
    payload: string
}

interface UpdateContactContactEmailAction {
    type: typeof UPDATE_CONTACT_CONTACT_EMAIL,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateContactDetailsLocaleAction {
    type: typeof UPDATE_CONTACT_DETAILS_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}
interface UpdateContactDetailsAction {
    type: typeof UPDATE_CONTACT_DETAILS,
    payload: string
}

interface UpdateContactEmailAction {
    type: typeof UPDATE_CONTACT_EMAIL,
    payload: string
}

interface UpdateContactFirstNameAction {
    type: typeof UPDATE_CONTACT_FIRST_NAME,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateContactFunctionAction {
    type: typeof UPDATE_CONTACT_FUNCTION,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateContactLastNameAction {
    type: typeof UPDATE_CONTACT_LAST_NAME,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateContactPhoneNumberAction {
    type: typeof UPDATE_CONTACT_PHONE_NUMBER,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateContentTypeAction {
    type: typeof UPDATE_CONTENT_TYPE,
    payload: number[]
}

interface UpdateContractCurrencyAction {
    type: typeof UPDATE_CONTRACT_CURRENCY,
    payload: {
        value: null | Currency,
        index: number
    }
}
interface UpdateContractEventSiteDateAction {
    type: typeof UPDATE_CONTRACT_EVENT_SITE_DATE,
    payload: {
        value: null | EventSiteDate,
        index: number
    }
}

interface UpdateContractEndDateAction {
    type: typeof UPDATE_CONTRACT_END_DATE,
    payload: {
        value: null | Date,
        index: number
    }
}

interface UpdateContractNameAction {
    type: typeof UPDATE_CONTRACT_NAME,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateContractNameLocaleAction {
    type: typeof UPDATE_CONTRACT_NAME_LOCALE,
    payload: {
        value: {
            id: number,
            text: string
        },
        index: number
    }
}

interface UpdateContractSecondStockTypeAction {
    type: typeof UPDATE_CONTRACT_SECOND_STOCK_TYPE,
    payload: {
        value: null | 'ON_DEMAND',
        index: number
    }
}

interface UpdateContractStartDateAction {
    type: typeof UPDATE_CONTRACT_START_DATE,
    payload: {
        value: null | Date,
        index: number
    }
}

interface UpdateContractStockTypeAction {
    type: typeof UPDATE_CONTRACT_STOCK_TYPE,
    payload: {
        value: 'NORMAL' | 'ON_DEMAND' | 'FREELANCE',
        index: number
    }
}

interface UpdateCountryAction {
    type: typeof UPDATE_COUNTRY,
    payload: string
}
interface UpdateCountyCodeAction {
    type: typeof UPDATE_COUNTY_CODE,
    payload: string
}
interface UpdateContractTypeAction {
    type: typeof UPDATE_CONTRACT_TYPE,
    payload: string
}

interface UpdateVaContentTypeAction {
    type: typeof UPDATE_VA_CONTENT_TYPE,
    payload: string
}

interface UpdateFilterActivatedAction {
    type: typeof UPDATE_FILTER_ACTIVATED,
    payload: 'ACTIVATED' | 'DEACTIVATED' | 'BOTH'
}

interface UpdateFilterCountryAction {
    type: typeof UPDATE_FILTER_COUNTRY,
    payload: IataCountry[]
}

interface UpdateFilterContentTypeAction {
    type: typeof UPDATE_FILTER_CONTENT_TYPE,
    payload: number[]
}

interface UpdateFilterVaContentTypeAction {
    type: typeof UPDATE_FILTER_VA_CONTENT_TYPE,
    payload: string
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterNameAction {
    type: typeof UPDATE_FILTER_NAME,
    payload: string
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateLanguageAction {
    type: typeof UPDATE_LANGUAGE,
    payload: string
}

interface UpdateNameAction {
    type: typeof UPDATE_NAME,
    payload: string
}

interface UpdatePaymentDelayAction {
    type: typeof UPDATE_PAYMENT_DELAY,
    payload: {
        value: Settlement | null,
        index: number
    }
}

interface UpdatePaymentDelayCurrencyAction {
    type: typeof UPDATE_PAYMENT_DELAY_CURRENCY,
    payload: {
        value: null | Currency,
        index: number
    }
}

interface UpdatePaymentDelayNegativeAction {
    type: typeof UPDATE_PAYMENT_DELAY_NEGATIVE,
    payload: {
        value: boolean,
        index: number
    }
}

interface UpdatePaymentDelayTypeAction {
    type: typeof UPDATE_PAYMENT_DELAY_TYPE,
    payload: {
        value: 'BOOKING' | 'ARRIVAL' | 'DEPARTURE',
        index: number
    }
}

interface UpdatePaymentTypeAction {
    type: typeof UPDATE_PAYMENT_TYPE,
    payload: string[]
}

interface UpdatePhoneNumberAction {
    type: typeof UPDATE_PHONE_NUMBER,
    payload: string
}
interface UpdateVatNumberAction {
    type: typeof UPDATE_VAT_NUMBER,
    payload: string | number
}
interface UpdateFiscalCodeAction {
    type: typeof UPDATE_FISCAL_CODE,
    payload: string | number
}
interface UpdateMasterCodeAction {
    type: typeof UPDATE_MASTER_CODE,
    payload: string | number
}
interface UpdateCounterCodeAction {
    type: typeof UPDATE_COUNTER_CODE,
    payload: string | number
}

interface UpdatePictureAction {
    type: typeof UPDATE_PICTURE,
    payload: null | Picture,
}

interface UpdatePictureProgressAction {
    type: typeof UPDATE_PICTURE_PROGRESS,
    payload: number
}

interface UpdateSecondaryPhoneNumberAction {
    type: typeof UPDATE_SECONDARY_PHONE_NUMBER,
    payload: string
}
interface UpdateMobilePhoneNumberAction {
    type: typeof UPDATE_MOBILE_PHONE_NUMBER,
    payload: string
}

interface UpdateZipCodeAction {
    type: typeof UPDATE_ZIP_CODE,
    payload: string
}
interface UpdateWebsiteAction {
    type: typeof UPDATE_WEBSITE,
    payload: string
}

export type CustomProviderActionTypes =
    SetPaymentDelayCreate |
    SetColumnsAction |
    ResizeColumnAction |
    AddBankingInformationAction |
    AddCodeAction |
    AddContactAction |
    AddContractAction |
    AddPaymentDelayAction |
    AddPreferencesAction |
    DeleteBankingInformationAction |
    DeleteCodeAction |
    DeleteContactAction |
    DeleteContractAction |
    DeletePaymentDelayAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetCustomProviderAction |
    ResetFiltersAction |
    SetCustomProviderActivateAction |
    SetBankingInformationDeleteAction |
    SetBankingInformationListAction |
    SetCodeDeleteAction |
    SetCodeListAction |
    SetContactDeleteAction |
    SetContactListAction |
    SetContractActivateAction |
    SetContractListAction |
    SetContractLockAction |
    SetContractIsDeactivatedAction |
    SetCustomProviderAction |
    SetCustomProviderBankingInformationsAction |
    SetCustomProviderCodesAction |
    SetCustomProviderContractsAction |
    SetCustomProviderContactsAction |
    SetCustomProviderPaymentDelaysAction |
    SetCustomProviderPaymentDelayEditAction |
    SetEditStepAction |
    SetErrorsAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetListContractReloadAction |
    SetOrderByAction |
    SetPageAction |
    SetPaymentDelaysDeleteAction |
    SetPaymentDelaysListAction |
    SetPictureErrorsAction |
    SetPostFinishedAction |
    SetPreferencesAction |
    SetRunningAction |
    SetSearchAction |
    ToggleAutoBookingAction |
    ToggleColumnAction |
    ToggleContractActivatedAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleNewAction |
    ToggleEditAction |
    ToggleRefreshAction |
    UpdateActivationCountriesAction |
    UpdateAddressAction |
    UpdateAssistanceEmailAction |
    UpdateAssistancePhoneNumberAction |
    UpdateBankingAccountHolderAction |
    UpdateBankingAddressAction |
    UpdateBankingBicAction |
    UpdateBankingCityAction |
    UpdateBankingCountryAction |
    UpdateBankingCurrencyAction |
    UpdateBankingIbanAction |
    UpdateBankingNameAction |
    UpdateBankingZipCodeAction |
    UpdateBookingEmailAction |
    UpdateCityAction |
    UpdateCodeAction |
    UpdateProviderCodeAction |
    UpdateCodeCodeAction |
    UpdateCodeCurrencyAction |
    UpdateComplementaryAddressAction |
    UpdateContactContactEmailAction |
    UpdateContactDetailsLocaleAction |
    UpdateContactDetailsAction |
    UpdateContactEmailAction |
    UpdateContactFirstNameAction |
    UpdateContactFunctionAction |
    UpdateContactLastNameAction |
    UpdateContactPhoneNumberAction |
    UpdateContentTypeAction |
    UpdateContractCurrencyAction |
    UpdateContractEventSiteDateAction |
    UpdateContractEndDateAction |
    UpdateContractNameAction |
    UpdateContractNameLocaleAction |
    UpdateContractSecondStockTypeAction |
    UpdateContractStartDateAction |
    UpdateContractStockTypeAction |
    UpdateCountryAction |
    UpdateCountyCodeAction |
    UpdateContractTypeAction |
    UpdateVaContentTypeAction |
    UpdateFilterActivatedAction |
    UpdateFilterCountryAction |
    UpdateFilterContentTypeAction |
    UpdateFilterVaContentTypeAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterNameAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateLanguageAction |
    UpdateNameAction |
    UpdatePaymentDelayAction |
    UpdatePaymentDelayCurrencyAction |
    UpdatePaymentDelayNegativeAction |
    UpdatePaymentDelayTypeAction |
    UpdatePaymentTypeAction |
    UpdatePhoneNumberAction |
    UpdateVatNumberAction |
    UpdateFiscalCodeAction |
    UpdateMasterCodeAction |
    UpdateCounterCodeAction |
    UpdatePictureAction |
    UpdatePictureProgressAction |
    UpdateSecondaryPhoneNumberAction |
    UpdateMobilePhoneNumberAction |
    UpdateZipCodeAction |
    UpdateWebsiteAction;